export default {
  dbi_mobile_device_reports: '移动设备报告',
  dbi_mobile_device_reports_intro: '在本模块中，我们将为您展示月度移动设备报告。',

  dbi_reports_search_placeholder: '搜索报告标题',
  dbi_reports_loading: '加载中...',
  dbi_reports_loading_more: '加载更多...',
  dbi_reports_no_data: '当前筛选下无数据',

  dbi_insights_report: '洞察报告',
  dbi_game_research_report: '游戏研究报告',
  dbi_insights_report_intro: '从我们经验丰富的游戏行业内容创作者那里获得市场洞察。',
  dbi_game_research_report_intro: '这里展示的是由GRC支持的报告，更多细节请联系leenxu@tencent.com或donbli@tencent.com。',
  dbi_insights_report_search: '搜索任何话题或标签',
  dbi_insights_report_search_or_tag: '搜索任何话题或标签',
  dbi_insights_report_search_recent: '最近',
  dbi_insights_report_search_no_data: '无数据',
  dbi_insights_report_like: '点赞',
  dbi_insights_report_share: '分享',
  dbi_insights_report_general_game: '通用模块',
  dbi_insights_report_esports: '电竞模块',
  dbi_insights_report_market: '市场',
  dbi_insights_report_game_genres: '游戏 & 品类',
  dbi_insights_report_players: '玩家',
  dbi_insights_report_monetization: '商业化',
  dbi_insights_report_compliance: '合规',

  // IIC中心报告 Insights Center Reports
  dbi_insights_center_library: 'IIC中心报告',
  dbi_insights_center_library_intro:
    '在本模块中，我们将向您展示由Infinite Insight Center (IIC)提供支持的英文报告。如需了解更多信息，请随时联系huidonghe@tencent.com。',
  dbi_insights_center_library_fundamental_study: '基础研究',
  dbi_insights_center_library_grip: 'GRIP报告',
  dbi_insights_center_library_grip_competitor_analysis: '竞品分析',
  dbi_insights_center_library_grip_marker_event_recap: '市场事件回顾',
  // dbi_insights_center_library_ad_hoc_research: '专项研究',
  dbi_insights_center_library_regional_monthly_report: '区域月报',
  dbi_insights_center_library_regional_monthly_report_na: '北美',
  dbi_insights_center_library_regional_monthly_report_eu: '西欧',
  dbi_insights_center_library_regional_monthly_report_mena: '中东',
  dbi_insights_center_library_regional_monthly_report_latam: '拉美',

  dbi_imur_reports: 'iMur 报告',
  dbi_imur_reports_intro: '在本模块中，我们将为您展示由市场与用户研究集团（iMur）提供的报告，详情请查看 iMur 网页。',
  dbi_imur_reports_intro_global: '您好，如需获取iMur报告，请通过Studio的Pteam同事，联系iMur团队的teresalv沟通获取。',
  dbi_imur_reports_report_type: '报告类型',

  dbi_imur_reports_tab_white_paper: '白皮书',
  dbi_imur_reports_tab_monitoring_reports: '监控报告',
  dbi_imur_reports_tab_genres: '品类和竞争对手',
  dbi_imur_reports_tab_operation: '运营和发行',
  dbi_imur_reports_tab_specific: '特别报告',
  dbi_imur_reports_tab_game_companies: '游戏公司',
  dbi_imur_reports_tab_new_tech: '新型技术',

  dbi_imur_NA: '北美',
  dbi_imur_EU: '欧洲',
  dbi_imur_LATAM: '拉美',
  dbi_imur_SEA: '东南亚',
  dbi_imur_MENA: '中东',
  dbi_imur_Japan: '日本',
  'dbi_imur_W.EU': '西欧',
  dbi_imur_EA: '东亚',
  'dbi_imur_Turkey & Russia': '土俄',
  dbi_imur_SA: '南亚',
  dbi_imur_Africa: '非洲',
  dbi_imur_GR: '品类研究',
  dbi_imur_CR: '竞品研究',
  dbi_imur_CM: '竞品监测',
  dbi_imur_SR: '专项研究',
  dbi_imur_GC: '厂商',
  'dbi_imur_VR/AR': 'VR/AR',
  dbi_imur_Metaverse: '元宇宙',

  dbi_market_report: '市场报告',
  'dbi_market_report-download': '下载Excel底表',

  dbi_reports_lang_chi: '中文报告',
  dbi_reports_lang_eng: '英文报告',
  dbi_reports_all: '全部',
  dbi_reports_liked: '点赞量',
  dbi_reports_search_na_data: '抱歉，请尝试其他关键字进行搜索。',
  dbi_iic_reports_search_na_data: '当前版块报告正在规划当中，敬请期待。',

  dbi_insight_report_feedback_tips: '感谢您的反馈！',
  dbi_insight_report_share_success_tips1: '链接复制成功！',
  dbi_insight_report_share_success_tips2: '来看看我分享的这篇{type}报告吧！',
  dbi_report_share_success_insight: '洞察',
  dbi_report_share_success_insight_center_library: 'IIC中心报告',
  dbi_report_share_success_game_analysis: '游戏分析',
  dbi_report_share_success_game_research: '游戏研究',
  dbi_insight_report_load_failure_tips: '报告加载失败',
  dbi_insight_report_deleted_tips: '报告已被删除',
  dbi_insight_report_reload_tips: '请重新加载',
  dbi_insight_center_library_report_unavailable_download:
    '应报告所有人要求，该报告无法下载。请联系{email}了解更多详情。',
  dbi_game_analysis_report_title: '游戏分析',
  dbi_game_analysis_report_sub_title: '模块收录了有洞察性的游戏分析报告。',
  dbi_segment_english_report: '英语报告',
  dbi_segment_french_report: '法语报告',
  dbi_segment_italian_report: '意大利语报告',
  dbi_segment_german_report: '德语报告',
  dbi_segment_spanish_report: '西班牙语报告',
  dbi_segment_chinese_report: '中文报告',
  dbi_segment_japanese_report: '日语报告',
  dbi_segment_korean_report: '韩语报告',
  dbi_segment_portuguese_report: '葡萄牙语报告',
  dbi_segment_russian_report: '俄语报告',
  dbi_segment_polish_report: '波兰语报告',
  dbi_segment_arabic_report: '阿拉伯语报告',
  dbi_segment_turkish_report: '土耳其语报告',
  dbi_segment_thai_report: '泰语报告',
  dbi_segment_vietnamese_report: '越南语报告',
  dbi_segment_indonesian_report: '印尼语报告',
  dbi_reports_likes: '点赞数',
  dbi_reports_views: '浏览量',
  dbi_reports_upload_time: '上传时间',

  dbi_reports_email_copy_success: '复制成功',
  dbi_reports_email_copy_failed: '复制失败，请重试',

  dbi_reports_casual_games_reports_title: '休闲游戏报告',
  dbi_reports_casual_games_reports_sub_title: '为您提供休闲游戏相关的精选报告',
  dbi_reports_market_reports: '市场报告',
  dbi_reports_analysis_reports: '分析报告',

  dbi_report_search_title: 'Report Search',
  dbi_report_search_placeholder: '搜索任何游戏、AI 行业相关洞察',
  dbi_report_search_button: '搜索',
  dbi_report_search_section_searching: '搜索中...',
  dbi_report_search_stats_total_reports: '篇报告',
  dbi_report_search_stats_popular_games: '热门游戏覆盖',
  dbi_report_search_stats_data_sources: '数据源',
  dbi_report_search_stats_ai_practices: '游戏 AI 实践',
  dbi_report_search_section_latest: '最新报告',
  dbi_report_search_section_popular: '热门报告',
  dbi_report_search_recent_title: '历史',
  dbi_report_search_no_recent: '暂无搜索记录',
  dbi_report_search_no_data: '暂无数据',
  dbi_report_search_no_data_desc_line1: '未找到与您搜索内容相关的结果。',
  dbi_report_search_no_data_desc_line2: '请尝试重新搜索。',
  dbi_report_search_empty_title: '暂无报告',
  dbi_report_search_empty_desc: '报告内容正在准备中，请稍后再来查看。',
};
